module.exports = __webpack_public_path__ + "img/logo_york_home.ec9e1d0e.png";